import { useSelector } from "react-redux";

export const useIsAdminUser = () => {
  const userEmail = useSelector(state => state.session.userEmail);
  const mocked = useSelector(state => state.session.mocked);

  return mocked || /@insticator.com\s*$/.test(userEmail)
}